module.exports = __webpack_public_path__ + "efbc0858df2a4dd2175a08dee815a068.fbx";